import { useEffect, useState, useRef } from "react";
import BSNavbar from "../../component/Navbar/Navbar";
import ProfessorTemplate from "../../util/ProfessorTemplate";
import { Modal, Form, Dropdown, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { update, clearForm } from "../../features/saveProfessorForm/saveProfessorForm";
import { saveProfessorForm } from "../../features/saveProfessorForm/saveProfessorForm";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { selectEditID } from "../../features/professorEditID/professorEditID";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useLocation } from "react-router-dom";
import "./ProfessorNewComment.css";

const ProfessorNewComment = () => {
  const [title, setTitle] = useState("");
  const [show, setShow] = useState(false);
  const [content, setContent] = useState(ProfessorTemplate);
  const [isCopied, setIsCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedProfessor, setselectedProfessor] = useState({id: "", name: ""});
  const windowWidth = useSelector(selectWindowWidth);
  const editID = useSelector(selectEditID);
  const titleRef = useRef(null);
  const contentRef = useRef(null);
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const savedFormData = useSelector(saveProfessorForm);
  const location = useLocation();
  //const { instituteIDs } = location.state || {};
  //const [selectedInstitutes, setSelectedInstitutes] = useState([]);
  const [rating, setRating] = useState(0); 
  const [prevRating, setPrevRating] = useState(0);

  // new professor
  const [showAddProfessorModal, setShowAddProfessorModal] = useState(false);
  const [newProfessorName, setNewProfessorName] = useState("");
  const [collegeList, setCollegeList] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [collegeId, setCollegeId] = useState(null);
  const [instituteList, setInstituteList] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [instituteId, setInstituteId] = useState(null);

  const checkLoginStatus = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
        method: 'POST',
        credentials: 'include'
      }).then(res => res.json());
    } catch {
      navigate('/home');
    }
  };

  const autoResize = () => {
    if (contentRef.current) {
      contentRef.current.style.height = `${contentRef.current.scrollHeight}px`;
    }
    if (titleRef.current) {
      titleRef.current.style.height = "auto";
      titleRef.current.style.height = `${titleRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    autoResize();
  }, [content, title]);

  const searchProfessor = async () => {
    if (!collegeId) {
      console.error("未選擇學院 ID");
      return;
    }
    
    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/professor_reviews/professors/${collegeId}`);
      if (!res.ok) {
        throw new Error(`Error fetching for ID: ${collegeId}`);
      }
      const data = await res.json();
      const professorList = Array.isArray(data) ? data : [];
      setSuggestions(professorList);
      setDropdownVisible(true);
    } catch (error) {
      console.error("獲取教授數據失敗：", error);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };
    
  useEffect(() => {
    if (collegeId) {
      searchProfessor();
    }
  }, [collegeId]);

  // handle the selection of dropdown
  const handleDropdownSelect = (id, name) => {
    if (!id || !name) {
      console.error("Invalid professor selection:", { id, name });
      return;
    }
    setselectedProfessor({ id, name });
  };

  /*const handleNavigateToNewCourse = () => {
    navigate("/new-professor");
  };*/

  const handleSave = () => {
    const formData = {
      content,
      selectedCollege,
      selectedInstitute,
      selectedProfessor,
      rating,
    };
    dispatch(update(formData));
    alert("儲存成功!");
  };

  useEffect(() => {
    if (savedFormData) {
      setContent(savedFormData.content);
      setSelectedCollege(savedFormData.selectedCollege);
      setSelectedInstitute(savedFormData.selectedInstitute);
      setselectedProfessor(savedFormData.selectedProfessor);
      setRating(savedFormData.rating);
    }
  }, [savedFormData]);

  const getEditedComment = async () => {
    if (editID.length === 0) return;
  
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/professor_reviews/reviews/all?review_id=${editID}`,
      {
        method: "GET",
      }
    ).then((res) => res.json());
    
    const editedReview = response.reviews[0];
  
    if (editedReview) {
      setselectedProfessor({ id: editedReview.professor_id, name: editedReview.professor_name });
      setRating(editedReview.rating);
      setContent(editedReview.review_content);

      let colleges = collegeList;
      if (!colleges || colleges.length === 0) {
        const collegeRes = await fetch(
          `${process.env.REACT_APP_API_URL}/professor_reviews/colleges`
        );
        colleges = await collegeRes.json();
        setCollegeList(colleges);
      }

      const matchedCollege = colleges.find(
        (c) => c.id === editedReview.college_id
      );
      if (matchedCollege) {
        setSelectedCollege(matchedCollege);
        setCollegeId(matchedCollege.id);

        const instituteRes = await fetch(
          `${process.env.REACT_APP_API_URL}/professor_reviews/institutes/${matchedCollege.id}`
        );
        const institutes = await instituteRes.json();
        setInstituteList(institutes);

        const matchedInstitute = institutes.find(
          (i) => i.id === editedReview.institute_id
        );
        if (matchedInstitute) {
          setSelectedInstitute(matchedInstitute);
          setInstituteId(matchedInstitute.id);
        }
      }
    } else {
      console.error("找不到對應的 review");
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    checkLoginStatus();
    getEditedComment();

    return () => controller.abort();
  }, []);

  const handleSure = (e) => {
    e.preventDefault();

    if (rating === 0) {
      setShow(false);
      return;
    }
    if (editID.length === 0) {
      handleSubmit();
      dispatch(clearForm());
    } else {
      handleEdit();
    }
  };

  const handleSubmit = async () => {
    await fetch(process.env.REACT_APP_API_URL + "/professor_reviews/reviews", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        professor_id : selectedProfessor.id || 0,
        college_id: collegeId || 0,
        institute_id: instituteId || 0,
        review_content: content,
        rating : rating,
      }),
    }).then(() => {
      navigate("/professor/comment");
    });
  };

  const handleEdit = async () => {
    await fetch(`${process.env.REACT_APP_API_URL}/professor_reviews/reviews/${editID}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        professor_id: parseInt(selectedProfessor.id),
        college_id: collegeId || 0,
        institute_id: instituteId || 0,
        review_content: content,
        rating : rating,
      }),
    }).then(() => {
      navigate("/professor/my-comment");
    });
  };

  const loadColleges = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/professor_reviews/colleges`);
      const data = await response.json();
      setCollegeList(data);
    } catch (error) {
      console.error("獲取學院失敗：", error);
    }
  };
  
  const loadInstitutes = async (eventKey) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/professor_reviews/institutes/${eventKey}`);
      const data = await response.json();
      setInstituteList(data);
    } catch (error) {
      console.error("獲取系所失敗：", error);
    }
  };
  
  const addProfessor = async () => {
    if(!instituteId) {
      alert("請先選擇系所！");
      setShowAddProfessorModal(false);
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/professor_reviews/professors?college_id=${collegeId}`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: newProfessorName }),
        }
      );
      if (response.ok) {
        const newProfessor = await response.json();
        setShowAddProfessorModal(false);
        setNewProfessorName("");
        setselectedProfessor({ id: newProfessor.professor_id, name: newProfessorName });
        searchProfessor();
      } else {
        alert("新增教授失敗！");
        setShowAddProfessorModal(false);
      }
    } catch (error) {
      console.error("新增教授失敗：", error);
    }
  };
  
  useEffect(() => {
    loadColleges();
  }, []);

  const handleRatingChange = (rate) => {
    if (rate === 1 && prevRating === 1) {
      setRating(0);
      setPrevRating(0);
    } else {
      setRating(rate);
      setPrevRating(rate);
    }
  };

  const handleCollegeSelect = (eventKey) => {
    const college = collegeList.find((c) => c.id === parseInt(eventKey, 10));
    setSelectedCollege(college);
    setCollegeId(college.id);
    loadInstitutes(college.id);

    setSelectedInstitute(null);
    setInstituteId(null);
    setselectedProfessor({ id: "", name: "" });
  };

  const handleInstituteSelect = (eventKey) => {
    if(!collegeId) {
      alert("請先選擇學院！");
      return;
    }

    const institute = instituteList.find((i) => i.id === parseInt(eventKey, 10));
    setSelectedInstitute(institute);
    setInstituteId(institute.id);
  }

  useEffect(() => {
    setInstituteId(null); 
  }, [collegeId]);

  return (
    <div style={{ background: '#dfd8cd', minHeight: '100vh', paddingBottom: '20px' }}>
      <BSNavbar bg={'#dfd8cd'}/>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {rating === 0
              ? "提醒"
              : `確認${editID.length === 0 ? "上傳" : "編輯"}`}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {rating === 0
            ? "請至少選擇一顆星"
            : `確認要${editID.length === 0 ? "上傳" : "編輯"}心得嗎？`}
        </Modal.Body>

        <Modal.Footer>
          {rating === 0 ? (
            <Button variant="secondary" onClick={() => setShow(false)}>
              確認
            </Button>
          ) : (
            <>
              <Button variant="secondary" onClick={() => setShow(false)}>
                取消
              </Button>
              <Button variant="success" onClick={handleSure}>
                確認
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={showAddProfessorModal} onHide={() => setShowAddProfessorModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>新增教授</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>教授名字</Form.Label>
            <Form.Control
              type="text"
              placeholder="輸入教授名字 ( 請輸入正確名字 )"
              value={newProfessorName}
              onChange={(e) => setNewProfessorName(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowAddProfessorModal(false)}>
          取消
        </Button>
        <Button variant="success" onClick={addProfessor}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
      <Form
        className="form-container mt-5 mb-5"
        style={{
          width:
            windowWidth >= 1200 ? "50%" : windowWidth > 900 ? "70%" : "80%",
          margin: "auto",
        }}
      >
        {editID.length === 0 && (
          <Button
            variant="warning"
            style={{ margin: "auto", marginLeft: "15px" }}
            disabled={selectedProfessor.name === "" || content.trim() === ""}
            onClick={handleSave}
          >
            儲存
          </Button>
        )}
        <Button
          variant="success"
          style={{ margin: "auto", marginLeft: "15px" }}
          disabled={selectedProfessor.name === "" || content.trim() === ""}
          onClick={() => setShow(true)}
        >
          發布
        </Button>
        
        <div className="d-flex justify-content-between">
        {/* College Dropdown */}
        <Dropdown onSelect={handleCollegeSelect} style={{ width: "25%" }}>
          <Dropdown.Toggle
            className="custom-dropdown-toggle"
            style={{ width: "100%", textAlign: "left", marginTop: "20px" }}
          >
            {selectedCollege ? selectedCollege.name : "選擇學院"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="custom-dropdown-menu" style={{ width: "100%" }}>
            {collegeList.map((college) => (
              <Dropdown.Item key={college.id} eventKey={college.id}>
                {college.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        {/* Institute Dropdown */}
        <Dropdown onSelect={handleInstituteSelect} disabled={!collegeId} style={{ width: "40%" }}>
          <Dropdown.Toggle
            className="custom-dropdown-toggle"
            style={{ width: "100%", textAlign: "left", marginTop: "20px" }}
          >
            {selectedInstitute ? selectedInstitute.name : "選擇系所"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="custom-dropdown-menu" style={{ width: "100%" }}>
            {instituteList.map((institute) => (
              <Dropdown.Item key={institute.id} eventKey={institute.id}>
                {institute.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        {/* Professor Dropdown */}
        <Dropdown style={{ width: "30%" }}>
          <Dropdown.Toggle
            className="custom-dropdown-toggle"
            style={{ width: "80%", textAlign: "left", marginTop: "20px" }}
          >
            {selectedProfessor.name || "請選擇教授"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="custom-dropdown-menu" style={{ width: "80%", textAlign: "left" }}>
            {suggestions.length > 0 ? (
              suggestions.map((professor) => (
                <Dropdown.Item
                  key={professor.id}
                  onClick={() => handleDropdownSelect(professor.id, professor.name)}
                >
                  {professor.name}
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item disabled>無對應教授</Dropdown.Item>
            )}
            <Dropdown.Item 
              onClick={() => setShowAddProfessorModal(true)}
              style={{
                backgroundColor: "#f8d7da",
                color: "#721c24",
                fontWeight: "bold",  // Bold text for emphasis
                borderTop: "1px solid #721c24",
              }}
            >
              新增教授
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
          {/*<OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">新增教授</Tooltip>}
          >
          <Button
            variant="outline-primary"
            className="custom-button"
            style={{
              marginLeft: "25px",
              height: windowWidth > 900 ? "40px" : "35px",
              width: windowWidth > 900 ? "40px" : "35px",
              borderColor: '#4b3615',
              color : '#4b3615',
              display: "flex",
              justifyContent: "center",
              alignItems: "center", 
            }}
            onClick={() => setShowAddProfessorModal(true)}
          >
          ＋
          </Button>
          </OverlayTrigger>*/}
        
        
        <div className="rating-container mt-3">
          {[...Array(5)].map((_, index) => {
            const starValue = index + 1;
            return (
              <span
                key={starValue}
                className={`star ${
                  starValue <= rating ? "selected" : ""
                }`}
                onClick={() => handleRatingChange(rating === starValue ? 0 : starValue)}
              >
                ★
              </span>
            );
          })}
        </div>
        <Form.Control
          as="textarea"
          className="mt-3"
          ref={contentRef}
          placeholder="輸入評論內容"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          style={{
            fontSize: windowWidth > 900 ? "20px" : "15px",
            border: "0",
            resize: "none",
            backgroundColor: "#ebe8e4",
            color: "#4b3615",
          }}
        />
      </Form>
    </div >
  );
};

export default ProfessorNewComment;
